import Modal from "react-bootstrap/Modal";
import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import "../../Style/Checkbox.scss";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import "../../Style/__button.scss";
import "../ClientsCRUD/ClientsModal.scss";
import "./ClientBranchesModal.scss";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "react-select";
import Autocomplete from "@mui/material/Autocomplete";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { AddElementsButton } from "../../Components/AddElementsButton";

function InsertClientBranches(props) {
  const headers = authHeader();
  const isEditMode = props.mode === "edit";

  const [clientBranchID, setClientBranchID] = useState(null);
  const [name, setName] = useState("");
  const [IdNumber, setIdNumber] = useState("");
  const [adress, setAdress] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [clientID, setClientID] = useState(null);
  const [accField, setAccfield] = useState(null);
  const [clients, setClients] = useState([]);

  const [stateid, setStateID] = useState("");
  const [stateName, setStateName] = useState("");
  const [states, setStates] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);

  const [city, setCity] = useState([]);
  const [filteredCity, setFilteredCity] = useState([]);
  const [cityID, setCityID] = useState("");
  const [cityName, setCityName] = useState("");

  const [searchTerm, setSearchTerm] = useState("");

  const [nameError, setNameError] = useState("");
  const [clientError, setClientError] = useState("");
  const [idNumberError, setIdNumberError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [stateError, setStateError] = useState("");
  const [cityError, setCityError] = useState("");

  const initialSnapshotRef = useRef(null);
  const [showConfirmClose, setShowConfirmClose] = useState(false);

  const resetForm = () => {
    setClientBranchID(null);
    setName("");
    setIdNumber("");
    setAdress("");
    setIsActive(true);
    setIsSubmitting(false);
    setClientID(null);
    setAccfield(null);
    setStateID("");
    setStateName("");
    setCity([]);
    setCityID("");
    setCityName("");
    setSearchTerm("");
    setNameError("");
    setClientError("");
    setIdNumberError("");
    setAddressError("");
    setStateError("");
    setCityError("");
    initialSnapshotRef.current = null;
    setShowConfirmClose(false);
  };

  const asText = (value) => (value == null ? "" : String(value));

  const setFormFromBranch = (branch) => {
    const nextBranchID = branch?.ClientBranchID ?? null;
    const nextName = asText(branch?.ClientBranchName);
    const nextClientID = branch?.AccountID ?? null;
    const nextIdNumber = asText(branch?.ClientBranchIdentificationNumber);
    const nextAddress = asText(branch?.ClientBranchAddress);
    const nextStateID = branch?.StateID ?? "";
    const nextStateName = asText(branch?.StateName);
    const nextCityID = branch?.CityID ?? "";
    const nextCityName = asText(branch?.CityName);
    const nextIsActive =
      typeof branch?.IsActive === "boolean" ? branch.IsActive : true;

    setClientBranchID(nextBranchID);
    setName(nextName);
    setClientID(nextClientID);
    setAccfield(
      nextClientID
        ? {
            AccountID: nextClientID,
            AccountName: branch?.AccountName ?? "",
            IdentificationNumber: branch?.IdentificationNumber ?? "",
          }
        : null,
    );
    setIdNumber(nextIdNumber);
    setAdress(nextAddress);
    setStateID(nextStateID);
    setStateName(nextStateName);
    setCityID(nextCityID);
    setCityName(nextCityName);
    setIsActive(nextIsActive);

    setSearchTerm("");
    setNameError("");
    setClientError("");
    setIdNumberError("");
    setAddressError("");
    setStateError("");
    setCityError("");
    setIsSubmitting(false);
    setShowConfirmClose(false);

    initialSnapshotRef.current = {
      name: nextName,
      clientID: nextClientID,
      idNumber: nextIdNumber,
      address: nextAddress,
      stateID: nextStateID,
      cityID: nextCityID,
      isActive: nextIsActive,
    };
  };

  const isDirty = useMemo(() => {
    if (!isEditMode) {
      return (
        name.trim() !== "" ||
        IdNumber !== "" ||
        adress.trim() !== "" ||
        clientID != null ||
        stateid !== "" ||
        cityID !== ""
      );
    }

    const snapshot = initialSnapshotRef.current;
    if (!snapshot) {
      return false;
    }

    return (
      name !== snapshot.name ||
      clientID !== snapshot.clientID ||
      IdNumber !== snapshot.idNumber ||
      adress !== snapshot.address ||
      stateid !== snapshot.stateID ||
      cityID !== snapshot.cityID ||
      isActive !== snapshot.isActive
    );
  }, [isEditMode, name, clientID, IdNumber, adress, stateid, cityID, isActive]);

  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "states", { headers })
      .then((response) => {
        setStates(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const fetchCityByState = async (selectedStateID) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Cities/getcitybystate",
        { headers, params: { stateid: selectedStateID } },
      );
      setCity(response.data);
    } catch (error) {
      if (error.response?.data?.errorMessage) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchClients = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByLedger",
        { headers, params: { ledger: 105 } },
      );
      setClients(response.data);
    } catch (error) {
      if (error.response?.data?.errorMessage) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  useEffect(() => {
    if (!props.show) {
      return;
    }

    fetchClients();
    if (isEditMode) {
      if (!props.initialData) {
        return;
      }

      setFormFromBranch(props.initialData);
      if (props.initialData.StateID) {
        fetchCityByState(props.initialData.StateID);
      }
      return;
    }

    resetForm();
  }, [props.show, props.initialData, isEditMode]);

  useEffect(() => {
    setFilteredStates(
      states.filter((data) =>
        data.StateName.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [searchTerm, states]);

  useEffect(() => {
    setFilteredCity(
      city.filter((data) =>
        data.CityName.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [searchTerm, city]);

  useEffect(() => {
    if (!stateid || stateName) {
      return;
    }

    const matchedState = states.find((entry) => entry.StateID === stateid);
    if (matchedState) {
      setStateName(matchedState.StateName);
    }
  }, [stateid, stateName, states]);

  useEffect(() => {
    if (!cityID || cityName) {
      return;
    }

    const matchedCity = city.find((entry) => entry.CityID === cityID);
    if (matchedCity) {
      setCityName(matchedCity.CityName);
    }
  }, [cityID, cityName, city]);

  const handleInputChange = (newValue) => {
    setSearchTerm(newValue.replace(/\W/g, ""));
  };

  const handleAutocompleteChangeClient = (event, value) => {
    if (value && value.AccountID) {
      setClientID(value.AccountID);
      setAccfield(value);
      setClientError("");
    } else {
      setClientID(null);
      setAccfield(null);
    }
  };

  const handleFilterState = (selectedOption) => {
    if (selectedOption && selectedOption.StateID) {
      setStateID(selectedOption.StateID);
      setStateName(selectedOption.label);
      setCityID("");
      setCityName("");
      setCity([]);
      fetchCityByState(selectedOption.StateID);
      setStateError("");
      setCityError("");
    } else {
      setStateID("");
      setStateName("");
      setCityID("");
      setCityName("");
      setCity([]);
    }
  };

  const handleFilterCity = (selectedOption) => {
    if (selectedOption && selectedOption.CityID) {
      setCityID(selectedOption.CityID);
      setCityName(selectedOption.label);
      setCityError("");
    } else {
      setCityID("");
      setCityName("");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isSubmitting) {
      return;
    }

    let hasValidationError = false;
    const trimmedName = name.trim();
    const trimmedIdNumber = IdNumber.trim();
    const trimmedAddress = adress.trim();

    if (trimmedName === "") {
      setNameError("Plotësoni emrin e njësisë");
      hasValidationError = true;
    } else {
      setNameError("");
    }

    if (clientID == null) {
      setClientError("Zgjidhni klientin");
      hasValidationError = true;
    } else {
      setClientError("");
    }

    if (trimmedIdNumber === "") {
      setIdNumberError("Plotësoni numrin identifikues");
      hasValidationError = true;
    } else {
      setIdNumberError("");
    }

    if (trimmedAddress === "") {
      setAddressError("Plotësoni adresën");
      hasValidationError = true;
    } else {
      setAddressError("");
    }

    if (stateid == null || stateid === "") {
      setStateError("Plotësoni shtetin");
      hasValidationError = true;
    } else {
      setStateError("");
    }

    if (cityID == null || cityID === "") {
      setCityError("Plotësoni qytetin");
      hasValidationError = true;
    } else {
      setCityError("");
    }

    if (hasValidationError) {
      return;
    }

    setIsSubmitting(true);

    const insertPayload = {
      ClientBranchName: trimmedName,
      AccountID: clientID,
      ClientBranchIdentificationNumber: trimmedIdNumber,
      ClientBranchAddress: trimmedAddress,
      CityID: cityID,
      IsActive: true,
    };

    const updatePayload = {
      ClientBranchID: clientBranchID,
      ClientBranchName: trimmedName,
      AccountID: clientID,
      ClientBranchIdentificationNumber: trimmedIdNumber,
      ClientBranchAddress: trimmedAddress,
      CityID: cityID,
      IsActive: isActive,
    };

    const submitRequest = isEditMode
      ? axios.put(ApiLink.API_URL + "ClientBranches", updatePayload, { headers })
      : axios.post(ApiLink.API_URL + "ClientBranches", insertPayload, { headers });

    submitRequest
      .then(() => {
        handleSuccess(
          isEditMode
            ? "Njësia e klientit u përditësua me sukses"
            : "Njësia e klientit u regjistrua me sukses",
        );
        resetForm();
        props.onHide();
        props.refreshData();
      })
      .catch((error) => {
        console.error(error);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
        } else {
          errorAlert("Ka ndodhur një gabim gjatë përpunimit të kërkesës.");
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const doClose = () => {
    if (isSubmitting) {
      return;
    }
    props.onHide();
    resetForm();
  };

  const handleClose = () => {
    if (isSubmitting) {
      return;
    }
    if (isDirty) {
      setShowConfirmClose(true);
      return;
    }
    doClose();
  };

  return (
    <>
      <Modal
        {...props}
        onHide={handleClose}
        backdrop={isSubmitting ? "static" : true}
        keyboard={!isSubmitting}
        size="lg"
        dialogClassName="clients-modal-dialog client-branches-modal-dialog"
        contentClassName="clients-modal-content client-branches-modal-content"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="clients-modal-header">
          <div className="clients-modal-header-content">
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="clients-modal-title"
            >
              {isEditMode
                ? "Përditëso njësinë e klientit"
                : "Krijo njësi të re të klientit"}
            </Modal.Title>
            <p className="clients-modal-subtitle">
              {isEditMode
                ? "Ndrysho të dhënat e njësisë dhe ruaji për përditësim në sistem."
                : "Plotësoni të dhënat e njësisë dhe ruani për ta shtuar në sistem."}
            </p>
            <div className="clients-modal-meta">
              <span className="clients-meta-pill">
                Fushat me * janë obligative
              </span>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="clients-modal-body">
          <form onSubmit={handleSubmit} className="clients-form">
            <section className="clients-section">
              <h6 className="clients-section-title">Informata Kryesore</h6>
              <div className="clients-grid clients-grid-2">
                <div className="clients-field clients-field-full">
                  <TextField
                    fullWidth
                    required
                    id="ClientBranchName"
                    label="Emri i Njësisë *"
                    variant="outlined"
                    type="text"
                    name="ClientBranchName"
                    value={name}
                    onChange={(event) => {
                      setName(event.target.value);
                      if (nameError) setNameError("");
                    }}
                    autoComplete="off"
                    size="small"
                  />
                  <span className="clients-error">
                    {nameError && `${nameError}`}
                  </span>
                </div>

                <div className="clients-field clients-field-full">
                  <label className="clients-select-label">
                    Kërkoni dhe zgjidhni klientin *
                  </label>
                  <Autocomplete
                    options={clients}
                    getOptionLabel={(option) =>
                      `${option.IdentificationNumber} - ${option.AccountName}` ||
                      ""
                    }
                    renderOption={(optProps, option) => (
                      <li
                        {...optProps}
                        key={option.AccountID}
                        style={{ borderBottom: "1px solid lightgray" }}
                      >
                        <span>
                          {option.IdentificationNumber}
                          <br />
                          {option.AccountName}
                        </span>
                      </li>
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.AccountID === value.AccountID
                    }
                    value={accField}
                    onChange={handleAutocompleteChangeClient}
                    ListboxProps={{
                      style: { maxHeight: "250px", overflow: "auto" },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Kërko Klientin *"
                        size="small"
                        fullWidth
                      />
                    )}
                  />
                  <span className="clients-error">
                    {clientError && `${clientError}`}
                  </span>
                </div>

                <div className="clients-field">
                  <TextField
                    fullWidth
                    required
                    id="ClientBranchIdentificationNumber"
                    label="Numri Identifikues *"
                    variant="outlined"
                    type="text"
                    name="ClientBranchIdentificationNumber"
                    value={IdNumber}
                    onChange={(event) => {
                      setIdNumber(event.target.value);
                      if (idNumberError) setIdNumberError("");
                    }}
                    autoComplete="off"
                    size="small"
                  />
                  <span className="clients-error">
                    {idNumberError && `${idNumberError}`}
                  </span>
                </div>

                <div className="clients-field">
                  <TextField
                    fullWidth
                    required
                    id="ClientBranchAddress"
                    label="Adresa *"
                    variant="outlined"
                    type="text"
                    name="ClientBranchAddress"
                    value={adress}
                    onChange={(event) => {
                      setAdress(event.target.value);
                      if (addressError) setAddressError("");
                    }}
                    autoComplete="off"
                    size="small"
                  />
                  <span className="clients-error">
                    {addressError && `${addressError}`}
                  </span>
                </div>

                <div className="clients-field">
                  <label className="clients-select-label">
                    Përzgjedh Shtetin *
                  </label>
                  <Select
                    inputId="StateID"
                    classNamePrefix="clients-select"
                    value={
                      stateid
                        ? { label: stateName, value: stateid, StateID: stateid }
                        : null
                    }
                    options={filteredStates.map((data) => ({
                      label: data.StateName,
                      value: data.StateID,
                      StateID: data.StateID,
                    }))}
                    onInputChange={handleInputChange}
                    onChange={handleFilterState}
                    isClearable
                    placeholder="Select"
                    noOptionsMessage={() => "Nuk u gjet asnjë përputhje"}
                    components={{ IndicatorSeparator: () => null }}
                  />
                  <span className="clients-error">
                    {stateError && `${stateError}`}
                  </span>
                </div>

                <div className="clients-field">
                  <label className="clients-select-label">
                    Përzgjedh Qytetin *
                  </label>
                  <Select
                    inputId="CityID"
                    classNamePrefix="clients-select"
                    value={
                      cityID
                        ? { label: cityName, value: cityID, CityID: cityID }
                        : null
                    }
                    options={filteredCity.map((data) => ({
                      label: data.CityName,
                      value: data.CityID,
                      CityID: data.CityID,
                    }))}
                    onInputChange={handleInputChange}
                    onChange={handleFilterCity}
                    isClearable
                    placeholder="Select"
                    noOptionsMessage={() => "Nuk u gjet asnjë përputhje"}
                    components={{ IndicatorSeparator: () => null }}
                  />
                  <span className="clients-error">
                    {cityError && `${cityError}`}
                  </span>
                </div>

                {isEditMode && (
                  <div className="clients-field clients-field-full">
                    <label className="clients-active-toggle">
                      <input
                        type="checkbox"
                        id="IsActive"
                        name="IsActive"
                        checked={isActive}
                        onChange={(event) => setIsActive(event.target.checked)}
                        className="clients-active-checkbox"
                        disabled={isSubmitting}
                      />
                      <span className="clients-active-copy">
                        <span className="clients-active-title">Statusi i njësisë</span>
                        <span className="clients-active-description">
                          {isActive ? "Njësia është aktive në sistem" : "Njësia është joaktive në sistem"}
                        </span>
                      </span>
                    </label>
                  </div>
                )}
              </div>
            </section>

            <div className="clients-modal-footer">
              <Button
                type="submit"
                variant="contained"
                className="clients-save-btn"
                disabled={isSubmitting || (isEditMode && !isDirty)}
              >
                {isSubmitting
                  ? "Duke ruajtur..."
                  : isEditMode
                    ? "Përditëso & Mbyll"
                    : "Ruaj & Mbyll"}
              </Button>
              <Button
                variant="outlined"
                className="clients-close-btn"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                Mbyll
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Dialog
        open={showConfirmClose}
        onClose={() => setShowConfirmClose(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Konfirmo mbylljen</DialogTitle>
        <DialogContent>
          Keni ndryshime të paruajtura. Nëse mbyllni tani, të dhënat do të
          humbin. A jeni të sigurt?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowConfirmClose(false)}
            variant="outlined"
          >
            Kthehu
          </Button>
          <Button onClick={doClose} variant="contained" color="error">
            Po, mbyll pa ruajtur
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default function ClientBranchesModal(props) {
  const [internalModalShow, setInternalModalShow] = React.useState(false);
  const isControlled = typeof props.show === "boolean";
  const modalShow = isControlled ? props.show : internalModalShow;

  const openModal = () => {
    if (!isControlled) {
      setInternalModalShow(true);
    }
  };

  const closeModal = () => {
    if (isControlled) {
      if (props.onHide) props.onHide();
    } else {
      setInternalModalShow(false);
    }
  };

  const handleRefreshData = () => {
    if (props.fetchData) {
      props.fetchData();
    }
  };

  return (
    <>
      {!isControlled &&
        (props.type === "text" ? (
          <AddElementsButton
            text="Krijo njësi të klientit"
            onClick={openModal}
            icon="bi bi-plus-circle"
            className="button-68"
          />
        ) : props.type === "insert" ? (
          <AddElementsButton
            text="Krijo njësi të klientit"
            onClick={openModal}
            icon="bi bi-plus-circle"
            className="button-15"
          />
        ) : (
          <AddBoxIcon
            style={{ height: "30px", color: "black" }}
            onClick={openModal}
          />
        ))}

      <InsertClientBranches
        show={modalShow}
        onHide={closeModal}
        refreshData={handleRefreshData}
        mode={props.mode}
        initialData={props.initialData}
      />
    </>
  );
}

